export default "/images/Rubber.webp?59894499556676808d724b4f8784ed61";